import { render, staticRenderFns } from "./StockEdit.vue?vue&type=template&id=dcb465f2&scoped=true"
import script from "./StockEdit.vue?vue&type=script&lang=ts"
export * from "./StockEdit.vue?vue&type=script&lang=ts"
import style0 from "./StockEdit.vue?vue&type=style&index=0&id=dcb465f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb465f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcb465f2')) {
      api.createRecord('dcb465f2', component.options)
    } else {
      api.reload('dcb465f2', component.options)
    }
    module.hot.accept("./StockEdit.vue?vue&type=template&id=dcb465f2&scoped=true", function () {
      api.rerender('dcb465f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/StockEdit.vue"
export default component.exports